export default "__VITE_ASSET__DTWIUK_q__"